import { BaseApi } from './base.api.js';

export class WeaknessApi extends BaseApi {
    constructor(client) {
        super(client, '/weakness');
    }
}
